var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSendTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.858 1.80979C15.5922 1.7816 15.3032 1.82312 15.0128 1.93791C14.6528 2.07951 9.01201 4.45235 3.7538 6.66586L2.01637 7.39709C1.34359 7.66988 1.00391 8.11352 1.00391 8.7111C1.00391 9.12949 1.18097 9.69698 2.02574 10.0314L4.95845 11.2063C5.21204 11.9671 5.80104 13.7335 5.94904 14.2031C6.03703 14.4815 6.2593 15.1828 6.82088 15.3468C6.93607 15.386 7.05628 15.4062 7.17868 15.4062C7.53306 15.4062 7.78823 15.2412 7.91303 15.1452L9.77702 13.5687L12.041 15.6624C12.1282 15.7512 12.5897 16.1999 13.2097 16.1999C13.9833 16.1999 14.5701 15.5559 14.6925 14.9327C14.7589 14.5912 16.9424 3.63 16.9424 3.6316C17.1384 2.75243 16.786 2.29636 16.5596 2.10197C16.3656 1.93598 16.1239 1.83799 15.858 1.80979ZM15.3284 3.53786C15.0268 5.0498 13.3827 13.3026 13.1331 14.4921L9.82389 11.4313L7.57866 13.3328L8.20052 10.9001C8.20052 10.9001 12.4904 6.55773 12.7488 6.30494C12.9568 6.10255 13.0003 6.0316 13.0003 5.9612C13.0003 5.86761 12.9522 5.80027 12.841 5.80027C12.741 5.80027 12.6052 5.89609 12.5332 5.94089C11.6185 6.51112 7.72381 8.72995 5.80685 9.82044L3.02571 8.70954L4.37566 8.14237C7.81473 6.69443 13.9396 4.11543 15.3284 3.53786Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendTg);
export default __webpack_public_path__ + "static/media/icon_send_tg.e84d61dea1ca244abe72fe51ee73eaf3.svg";
export { ForwardRef as ReactComponent };